import React from 'react'
import styled from '@emotion/styled'

import {Brand} from '@vio/core/src/brand/types'

import {useDeviceLayout} from '../../../context/deviceLayout'
import {cssTheme} from '../../../themes'
import {NoStyleLink} from '../helpers/NoStyleLink'
import {Icon} from '../Icon'

interface Props {
  brand: Brand
}

export const SocialMediaLinks = styled.div`
  display: flex;
  align-items: center;
  max-height: ${cssTheme.layout.spacing.s500};
  gap: ${cssTheme.layout.spacing.s500};
`

export const SocialMediaLinksWidget = ({brand}: Props) => {
  const {isMobile} = useDeviceLayout()

  return (
    <SocialMediaLinks>
      <NoStyleLink
        href={brand.socials?.facebookUrl}
        target="_blank"
        title="Facebook"
      >
        <Icon name="Facebook" size={isMobile ? 'sm' : 'md'} />
      </NoStyleLink>
      <NoStyleLink
        href={brand.socials?.linkedinUrl}
        target="_blank"
        title="Linkedin"
      >
        <Icon name="Linkedin" size={isMobile ? 'sm' : 'md'} />
      </NoStyleLink>
    </SocialMediaLinks>
  )
}
